var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vs-chip',{class:['ag-grid-cell-chip', _vm.chipClass(_vm.params.data.bankAccount.bank)]},[(_vm.params.data.bankAccount.bank)?_c('span',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.labeler(_vm.params.data.bankAccount.bank)))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }